import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Prompt, useHistory, useParams } from 'react-router-dom';

import { Location } from 'history';

import PageTitle from '~/components/PageTitle';
import TabsContainer, { ITab } from '~/components/TabsContainer';
import { useAuth } from '~/hooks/auth';
import { useNavigation } from '~/hooks/Navigation';
import {
  getActivatedUsersRequest,
  getCamundaUsersRequest,
  getGroupsRequest,
  getUsersByGroupsRequest,
} from '~/store/modules/users/actions';
import { permissions } from '~/types/constants';

import AssignedTasks from './Assigned';
import AvailableTasks from './Available';
import HistoryTasks from './History';
import { Container } from './styles';

type ParamsType = {
  id: string;
};

interface ITasksTabs {
  [index: string]: number;
}

interface ITasksStatus {
  [index: number]: string;
}

const Tasks: React.FC = (): JSX.Element => {
  const TABS: ITab[] = [
    { label: 'Disponíveis', value: 0, content: <AvailableTasks /> },
    { label: 'Atribuídas', value: 1, content: <AssignedTasks /> },
    { label: 'Finalizadas', value: 2, content: <HistoryTasks /> },
  ];

  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<ParamsType>();
  const { checkPermission, user } = useAuth();

  const {
    confirmAndNavigate,
    canNavigate,
    setLocation,
    setConfirmationModal,
  } = useNavigation({
    customHeaderMessage: 'Os filtros serão descartados.',
  });

  const tabsIndex: ITasksStatus = {
    0: 'disponiveis',
    1: 'atribuidas',
    2: 'finalizadas',
  };

  const indexTabs: ITasksTabs = {
    disponiveis: 0,
    atribuidas: 1,
    finalizadas: 2,
  };

  const [value, setValue] = useState<number>(indexTabs[id]);

  const handleChange = (newValue: number) => {
    confirmAndNavigate(() => {
      history.push(`/tasks/${tabsIndex[newValue]}`);
      setValue(newValue);
    });
  };

  const handleCancel = (newLocation: Location): boolean => {
    if (canNavigate === true) {
      return true;
    }

    setLocation(newLocation);
    setConfirmationModal(true);
    return false;
  };

  useEffect(() => {
    if (
      user.groups.length === 1 &&
      checkPermission([permissions.VIEW_CLIENT_REQUEST])
    ) {
      const clientGroup = { id: 'client', name: 'Client', type: '' };

      dispatch(getUsersByGroupsRequest([clientGroup]));
    }

    dispatch(getActivatedUsersRequest());
    dispatch(getCamundaUsersRequest());
    dispatch(getGroupsRequest());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkPermission, dispatch]);

  return (
    <Container>
      <PageTitle>Tarefas</PageTitle>
      <TabsContainer
        ariaLabel="tasks_tabs"
        value={value}
        onChange={handleChange}
        options={TABS}
      />

      <Prompt
        when={!canNavigate}
        message={(location) => handleCancel(location)}
      />
    </Container>
  );
};

export default Tasks;
